var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-progress-container"},[_c('p',{staticClass:"progress-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:(_vm.percentageFill)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }